import React, { useEffect, useState } from 'react';
import { useUserInfo } from '@repository/auth/useUserInfo';
import JobRadarChart from '@components/phs/pacc/results/result/competencyResult/jobRecommend/jobRadarChart';
import JobBarChart from '@components/phs/pacc/results/result/competencyResult/jobRecommend/jobBarChart';
import { usePHSPACCCompetenceCurationJob } from '@components/phs/pacc/results/query/useCompetence';
import CompetencyCard from '../common/competencyCard';
import CompetencyInnerCard from '../common/competencyInnerCard';
import { PaccJobCurationVO } from '@domain/vo/phs/pacc/competence/PaccJobCurationResultVO';

interface JobRecommendProps {
  sn: number;
}

const JobRecommend = ({ sn }: JobRecommendProps) => {
  const { data: paccJobCurationResult } = usePHSPACCCompetenceCurationJob(sn);
  const { data: userInfo } = useUserInfo();
  const [selectedJobCuration, setSelectedJobCuration] = useState<PaccJobCurationVO | null>(null);
  const userName = userInfo?.name ?? '';

  useEffect(() => {
    if (paccJobCurationResult?.jobCurations) {
      setSelectedJobCuration(paccJobCurationResult.jobCurations[0]);
    }
  }, [paccJobCurationResult]);

  if (!paccJobCurationResult) return null;

  return (
    <CompetencyCard title={`${userName}님에게 잘 어울리는 개발 직무 추천`} cardType={'gray'} iconType={'job'}>
      <CompetencyInnerCard
        title={'나한테 맞는 BEST 직무는?'}
        subTitle={
          <>
            다양한 개발 직무 중 내 역량검사 결과와 딱 맞는 직무를 확인해보세요.
            <br />
            역량에 마우스를 올리면 해당 역량의 의미를 확인할 수 있어요.
          </>
        }
      >
        <JobRadarChart selectedJobCuration={selectedJobCuration} />
        <JobBarChart
          paccJobCurationResult={paccJobCurationResult}
          selectedJobCuration={selectedJobCuration}
          setSelectedJobCuration={setSelectedJobCuration}
        />
      </CompetencyInnerCard>
    </CompetencyCard>
  );
};

export default JobRecommend;
